import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../../utils/api';
import News from '../shorts/News';
import Tests from '../shorts/Tests';

import '../../assets/css/register.css'

const Register = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { email, password, username };

        try {
            await registerUser(data);
            navigate('/login');
        } catch (err) {
            setError('Something went wrong');
        }
    };

    return (
        <>
            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row-registration'>
                            <div className='category'>Registration</div>
                            <div className='register-form'>
                                <form onSubmit={handleSubmit}>
                                    <div className='input-group'>
                                        <label for="username">Benutzername</label>
                                        <input
                                            id="username"
                                            type="text"
                                            placeholder="Benutzername"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            autocomplete="username"
                                        />
                                    </div>
                                    <div className='input-group'>
                                        <label for="email">E-Mail</label>
                                        <input
                                            id="email"
                                            type="email"
                                            placeholder="E-Mail"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            autocomplete="email"
                                        />
                                    </div>
                                    <div className='input-group'>
                                        <label for="password">Passwort</label>
                                        <input
                                            id="password"
                                            type="password"
                                            placeholder="Passwort"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autocomplete="new-password"
                                        />
                                    </div>
                                    <div className='checkbox-group'>
                                        <input type="checkbox" id="agb" name="agb" value="agb" />
                                        <label for="agb">Ich akzeptiere die <a href="#">Nutzungsbestimmungen</a></label>
                                    </div>
                                    <button type="submit">Jetzt kostenlos registrieren</button>
                                </form>
                                {error && <div>{error}</div>}
                                <div className='login-box'>
                                    <div className='headline'>
                                        Du hast bereits ein Benutzerkonto?
                                    </div>
                                    <div className='subline'>
                                        Melde dich mit deinem Benutzerkonto an
                                    </div>
                                    <Link to="/login" className="btn-login" viewTransition>Zur Anmeldung</Link>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <Tests />
                            <News />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Register;
